export const UNPROTECTED_ROUTES = [
  '/',
  '/signup',
  '/users/password/edit',
  '/users/password/new',
  '/invite_user/new',
]
